 
import { React, useEffect, useState, useRef, useMemo } from "react";
import {  getList,postList,genericPost } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../Constants";
import cogoToast from "cogo-toast";
import { Modal } from "react-bootstrap";
import { FaSpinner, FaTimes } from "react-icons/fa";
import Select from 'react-select';

const ProjectWorkflows = (props) => {
  let {project} = props.location.state;

const [active_tab, setactive_tab] = useState(1)
  const [workflows, setworkflows] = useState([])
  const [workflow_levels, setworkflow_levels] = useState([])
  const [users, setUsers] = useState([])
  const [projects, setProjects] = useState([])

  const [selectedWorkflow, setselectedWorkflow] = useState(null)
   

  const [show_create_level_modal, setshow_create_level_modal] = useState(false)
  const [show_update_level_modal, setshow_update_level_modal] = useState(false)
  const [show_create_level_assignment_modal, setshow_create_level_assignment_modal] = useState(false)

  
  const [workflow_assignments, setworkflow_assignments] = useState([])
  const [selectedWorkflowLevel, setselectedWorkflowLevel] = useState(null)
  const [IsLoading, setIsLoading] = useState(false)
const [entity, setentity] = useState(null)

  useEffect(() => {
  listWorkflows();
  listUsers();
  listProjects();
}, [])


const listWorkflowLevels=async (id)=>{
  setIsLoading(true);
  setworkflow_levels(await postList(ENDPOINTS.LIST_WORKFLOW_LEVELS,{
  "workflow_id": id
  }));
  setIsLoading(false);
} 

const listWorkflows =async ()=>{
  setIsLoading(true);
  setworkflows(await getList(ENDPOINTS.LIST_WORKFLOWS));
  setIsLoading(false);
} 

const listUsers =async ()=>{
  setIsLoading(true);
  setUsers( await getList(ENDPOINTS.LIST_USERS))
  setIsLoading(false);
} 
const listProjects =async ()=>{
  setIsLoading(true);
  setProjects( await getList(ENDPOINTS.LIST_PROJECTS))
  setIsLoading(false);
} 

const listLevelAssignments =async (id)=>{
  setIsLoading(true);
  setworkflow_assignments( await postList(ENDPOINTS.LIST_WORKFLOW_LEVEL_ASSIGNMENTS,{"workflow_level_id":id}))
  setIsLoading(false);
} 
const createWorkflowLevel=(e)=>{


  e?.preventDefault(); 
  let data={
      
      "workflow_id":selectedWorkflow?.id,
      "name":e.target.name.value,
      "level_no":e.target.level_no.value,
      "type":e.target.type.value,
      "user_type":e.target.user_type.value,
  }
  
  genericPost(ENDPOINTS.CREATE_WORKFLOW_LEVEL,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        
        cogoToast.success(responseData.message);
  setshow_create_level_modal(false);
  listWorkflowLevels(selectedWorkflow?.id);
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });

}
const createWorkflowLevelAssignment=(e)=>{
 

  e?.preventDefault(); 
  let data=[{    
      "workflow_level_id":e.target.workflow_level_id.value,
      "entity_id":entity.value.toString(),
      "user_type":e.target.user_type.value,
      "resource_id":e.target.resource_id.value,
  }]
  
  genericPost(ENDPOINTS.CREATE_WORKFLOW_LEVEL_ASSIGNMENT,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        
        cogoToast.success(responseData.message);
  setshow_create_level_assignment_modal(false);
  listLevelAssignments(selectedWorkflowLevel?.id);
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });

}
const updateWorkflowLevel=(e)=>{


  e?.preventDefault(); 
  let data={
      
    "workflow_level_id":e.target.workflow_level_id.value,
      "workflow_id":e.target.workflow_id.value,
      "name":e.target.name.value,
      "level_no":e.target.level_no.value,
      "type":e.target.type.value,
      "user_type":e.target.user_type.value,
  }
  
  genericPost(ENDPOINTS.UPDATE_WORKFLOW_LEVEL,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        
        cogoToast.success(responseData.message);
  setshow_update_level_modal(false);
  listWorkflowLevels(selectedWorkflow?.id);
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });

}
  return (
 
 
<div className="page-wrapper">
 
   
 
        <div className="page-body">
          <div className="container-xl">
            <div className="card g-0 p-10">

           <h1> {project.project_name}</h1>
           <div className="row">
           
            <div className="col-md-6">
              
            <select name="workflowId" className="form-control" onChange={(e)=>{
  if(e.target.value==""){
setselectedWorkflow(null);
setworkflow_levels([]);
  }else{

 
      setselectedWorkflow(workflows.filter((w)=>w.id=e.target.value)[0]);
      listWorkflowLevels(e.target.value);
    }
    }}>
    <option value={""}>Select Workflow</option>
    {workflows?.map((w)=> {
    
    return  <option value={w.id} 
     >
    
      {w.name} ({w.total_levels} levels)
      
      </option>
    })}
  </select> <br/>
              </div>
              <div className="col-md-2">
                </div>
           </div>




 </div>
 
 {workflow_levels.length>0 ? <div className="card">

              <div className="row g-0">
                <div className="col-12 col-md-3 border-end">
                  <div className="card-header">
                <h3>  {selectedWorkflow && <>   {selectedWorkflow?.name} </> } </h3>
                  </div>
                  <div className="card-body">
              

                    <h4 className="subheader">Levels</h4>
                    <div className="list-group list-group-transparent">

                      {workflow_levels?.map((l)=>{
                        return <a onClick={()=> {setactive_tab(l.id); setselectedWorkflowLevel(l); listLevelAssignments(l.id);}}   className={active_tab==l.id?"list-group-item list-group-item-action d-flex align-items-center active":"list-group-item list-group-item-action d-flex align-items-center"}>Level {l.level_no} - {l.name} </a>
                      })}
                    
                    </div>
                   
                  </div>
                </div>
                <div className="col-12 col-md-9 d-flex flex-column">
                  
                {workflow_levels?.map((l)=>{
                  if(active_tab==l.id){

                 
 return <div className="card-body mg-200">
  <div className="row">
    <div className="col-md-9">
    <h1>  {l.name} </h1>
    </div>
    <div className="col-md-3">
    <button className="btn btn-primary" onClick={()=>setshow_create_level_assignment_modal(true)}
     > Create Assignment </button>

    </div>
    </div>

 <div className="cardx">
                      <div className="card-header">
                        <h3 className="card-title">assignments & Actions </h3>
                      </div>
                      <div className="list-group list-group-flush list-group-hoverable">
                    
                        
                     
                      </div>
                    </div>
 {workflow_assignments.filter((ws)=>ws.workflow_level_id==l.id && ws.resource_id==project.id).map((w)=>{
  let user_name=users.filter((u)=> u.value==w.entity_id)[0]?.text;
  return      <div className="list-group-item">
  <div className="row align-items-center">
    <div className="col-auto"></div>
    <div className="col-auto">
    
        <span className="avatar">{user_name?.substring(0,2)?.toUpperCase() }</span>
      
    </div>
    <div className="col text-truncate">
      <span  className="text-reset d-block"> {user_name} </span>
      <div className="d-block text-secondary text-truncate mt-n1">

      <span className="badge bg-green"></span>  Approved , Document passed this step   <br/>
      <span className="badge bg-red"></span>  Rejected , This is another action comment  </div>
      
    

    </div>
    {/* <div className="col-auto">
      <a href="#" className="list-group-item-actions">
      
        <svg xmlns="http://www.w3.org/2000/svg" 
        className="icon text-secondary" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path></svg>
      
      </a>
    </div> */}
  </div>
</div>;
 })}

 </div>
  } 
                })}

      

                  
                </div>
              </div>
            </div>:<center><h3>Please select Workflow</h3></center>}


          </div>
        </div>
       
    





{show_create_level_modal && (
          <div>
            <Modal show={show_create_level_modal} onHide={() => null}>
              <div className="modal-status bg-primary modal-big"></div>

              <Modal.Header style={{ backGroundColor: "red", width: "100%" }}>
                <h3 style={{ width: "100%", marginTop: "3%" }}>
                  <div className="row">
                    <div className="col-md-6">
                      <Modal.Title>Create New Level</Modal.Title>
                    </div>
                    <div className="col-md-6">
                      <FaTimes
                        onClick={() => {
                          setshow_create_level_modal(false);
                        }}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          float: "right",
                        }}
                      />
                    </div>
                  </div>
                </h3>
              </Modal.Header>
              <Modal.Body>
<form onSubmit={createWorkflowLevel}>
  Name
  <input type="text" name="name" required className="form-control"></input>
  Level No.
  <input type="text" name="level_no" required className="form-control"></input>
  Type 
  <input type="text" name="type" required className="form-control"></input>

  User Type 
  <input type="text" name="user_type" required className="form-control"></input>

<br/>
{IsLoading? <> <FaSpinner></FaSpinner> </>: <input type="submit" className="btn btn-primary" value={"Create workflow Level"}/> }
</form>

              </Modal.Body>
            </Modal>
          </div>
        )}


 



{show_create_level_assignment_modal && (
          <div>
            <Modal show={show_create_level_assignment_modal} onHide={() => null}>
              <div className="modal-status bg-primary modal-big"></div>

              <Modal.Header style={{ backGroundColor: "red", width: "100%" }}>
                <h3 style={{ width: "100%", marginTop: "3%" }}>
                  <div className="row">
                    <div className="col-md-9">
                      <Modal.Title>Create Assignment for {selectedWorkflowLevel.name}</Modal.Title>
                    </div>
                    <div className="col-md-3">
                      <FaTimes
                        onClick={() => {
                          setshow_create_level_assignment_modal(false);
                        }}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          float: "right",
                        }}
                      />
                    </div>
                  </div>
                </h3>
              </Modal.Header>
              <Modal.Body>
<form onSubmit={createWorkflowLevelAssignment}>
  <input type="hidden" name="workflow_level_id" value={selectedWorkflowLevel.id}/>
  <input type="hidden" name="resource_id" value={project.id}/>

   


  Entity (User)

   

  <Select
        value={entity}
         onChange={setentity}
        options= {users?.map((u)=>{  
          return { value: u.value, label: u.text }  
          })}
      />
  <br/>
  User Type
  <select name="user_type" className="form-control">
    <option value={1}>User Type 1</option>
    <option value={2}>User Type 2</option>
   
  </select>
 

<br/>
{IsLoading? <> <FaSpinner></FaSpinner> </>: <input type="submit" className="btn btn-primary" value={"Create workflow Level Assignment"}/> }
</form>

              </Modal.Body>
            </Modal>
          </div>
        )}


</div>  
  )
}
  
export default ProjectWorkflows